
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-6b766bec\",\"scoped\":true,\"hasInlineConfig\":false}!./style.css")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./script.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6b766bec\"}!./template.html"),
  /* scopeId */
  "data-v-6b766bec",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/Adminpoint/Posts/index.vue
// module id = 249
// module chunks = 0